module.exports = __webpack_public_path__ + "static/media/side_logo.8aedc984.svg";